import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box, List, Typography } from '@mui/material';
import BalanceCom from '../../shared/components/student/BalanceCom';
import CustomDivider from '../../shared/utils/CustomDivider';
import { Blue_Border, Constants } from '../../shared/constants';
import { savingAmountData } from '../../data/amount';
import { coinedEarnData } from '../../data/coinedearn';
import { useVariableStore } from '../../store/createStudentStore';

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const TabBox = ({ children }) => {
    return (
        <Box sx={{ height: "100px", width: "100%", p: "25px 22px", }}


        >
            {children}
        </Box>
    )
}


const SavingAmount = () => {
    return (
        <TabBox>
            <Typography variant='h3' color='blue.main' textAlign={"center"}> ₹ 2,00,000</Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                <Typography variant='h6' color='blue.main' textTransform={"capitalize"}>Savings amount..</Typography>
                <img src={Constants.customImages.CoinedImg} alt='coined image' width={"35px"} />
            </Box>
        </TabBox>
    )
}


export const CoinEarned = () => {
    return (
        <Box
            sx={{
                width: { sm: "45%", xs: "85%" },
                border:Blue_Border,
                borderRadius: "15px",
                mx: { lg: "20px", xs: "0" },
                bgcolor: "#F2F6FF", p: "25px 22px"
            }}>
            <Typography variant='h5' color='blue.main' textAlign={"center"} textTransform={"capitalize"}>Coined Earned</Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 3 ,alignItems:"center" }}>
                <img src={Constants.customImages.Stack} alt='coined image' width={"35px"} height={"35px"} />
                <Typography variant='h3' color='blue.main'>250</Typography>

            </Box>
        </Box>
    )
}

const StudentBanlaceTab = () => {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        const newTitle = newValue === 0 ? savingAmountData.title : coinedEarnData.title;
        useVariableStore.setState({ value: newTitle }); 


    };



    return (
        <Box>
            <Box>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="transparent"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        "& .MuiTabs-flexContainer": {
                            flexWrap: "wrap", // Enables wrapping when needed
                            gap: { lg: 0, sm: "10px", xs: "10px" },
                            justifyContent: "space-between"
                        },
                    }}

                >
                    {[<SavingAmount />, <CoinEarned />].map((item, index) => (
                        <Tab
                            key={index}
                            {...a11yProps(index)}
                            sx={{
                                minWidth: { sm: "45%", xs: "100%" },
                                border: value === index ? "1px solid #4169E1" : "none",
                                borderRadius: "15px",
                                mx: { lg: "20px", xs: "0" },
                                bgcolor: "#F2F6FF"
                            }}
                            label={item}
                        />
                    ))}
                </Tabs>
            </Box>

            <>
                <CustomTabPanel value={value} index={0}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", m: "20px" }}>
                        <Typography variant='h5' fontWeight={500}>25 Jan 2025</Typography>
                        <Typography variant='h5' fontWeight={500}>- ₹ {savingAmountData.totol}<Typography variant='body2' component={"span"}> This month</Typography></Typography>
                    </Box>
                    <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
                    <List sx={{ mx: "20px" }}>
                        {savingAmountData.arr.map((item, index) => (
                            <>
                                <BalanceCom key={index} img={item.img} name={item.name} type={item.type} />

                            </>
                        ))}
                    </List>

                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", m: "20px" }}>
                        <Typography variant='h5' fontWeight={500}>25 Jan 2025</Typography>
                        <Typography variant='h5' fontWeight={500}> {coinedEarnData.totol} <Typography variant='body2' component={"span"}>This month</Typography></Typography>
                    </Box>
                    <CustomDivider size={"0px"} sx={{ borderBottom: "1px solid #E8E8E8" }} />
                    <List sx={{ mx: "20px" }}>
                        {coinedEarnData.arr.map((item, index) => (
                            <>
                                <BalanceCom key={index} img={item.img} name={item.name} coin={item.coin} />

                            </>
                        ))}
                    </List>

                </CustomTabPanel>


            </>



        </Box>
    );
};

export default StudentBanlaceTab;
